module.exports = __webpack_public_path__ + "static/media/Speech_and_language.aaf3a47a.png";